/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as fromPortalTeams from './portal-teams.reducer';
import * as PortalTeamsSelectors from './portal-teams.selectors';
import * as PortalTeamsActions from './portal-teams.actions';

@Injectable({
    providedIn: 'root'
})
export class PortalTeamsFacade {
    loaded$ = this.store.pipe(
        select(PortalTeamsSelectors.getPortalTeamsLoaded)
    );
    loading$ = this.store.pipe(
        select(PortalTeamsSelectors.getPortalTeamsLoading)
    );
    pagination$ = this.store.pipe(
        select(PortalTeamsSelectors.getPortalTeamsPagination)
    );
    error$ = this.store.pipe(select(PortalTeamsSelectors.getPortalTeamsError));
    allPortalTeams$ = this.store.pipe(
        select(PortalTeamsSelectors.getAllPortalTeams)
    );
    selectedPortalTeams$ = this.store.pipe(
        select(PortalTeamsSelectors.getSelected)
    );

    constructor(
        private store: Store<fromPortalTeams.PortalTeamsPartialState>
    ) {}

    public loadPortalTeams(query: any) {
        this.dispatch(PortalTeamsActions.loadPortalTeams({ query }));
    }

    public selectPortalTeam(id: string) {
        this.dispatch(PortalTeamsActions.selectPortalTeam({ id }));
    }

    public createPortalTeam(team: any) {
        this.dispatch(PortalTeamsActions.createPortalTeam({ payload: team }));
    }

    public updatePortalTeam(id: string, team: any) {
        this.dispatch(
            PortalTeamsActions.updatePortalTeam({ id, payload: team })
        );
    }

    public ensureTeamIsLoaded(teamId: string): void {
        this.store.dispatch(PortalTeamsActions.loadPortalTeam({ teamId }));
    }

    private dispatch(action: Action) {
        this.store.dispatch(action);
    }
}
